import type { Template } from "@/types";

export const PO_07_H3_V4: Template[] = [
    {
        id: "po-07-h3v4-01",
        name: "PO 01 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 44, y: 135, width: 539, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 474, width: 266, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 474, width: 265, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 740, y: 135, width: 196, height: 253, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 135, width: 195, height: 253, rotation: 0, imageRotation: 0 },
            { id: "6", x: 740, y: 395, width: 196, height: 253, rotation: 0, imageRotation: 0 },
            { id: "7", x: 943, y: 395, width: 195, height: 253, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-02",
        name: "PO 02 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 62, y: 159, width: 202, height: 151, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 317, width: 202, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 62, y: 474, width: 202, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 272, y: 159, width: 307, height: 466, rotation: 0, imageRotation: 0 },
            { id: "5", x: 675, y: 159, width: 342, height: 466, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 159, width: 168, height: 230, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1024, y: 396, width: 168, height: 229, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-03",
        name: "PO 03 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 36, y: 124, width: 562, height: 347, rotation: 0, imageRotation: 0 },
            { id: "2", x: 36, y: 478, width: 278, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 321, y: 478, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 124, width: 420, height: 535, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1081, y: 124, width: 135, height: 174, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1081, y: 305, width: 135, height: 174, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1081, y: 486, width: 135, height: 174, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-04",
        name: "PO 04 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 147, y: 74, width: 332, height: 209, rotation: 0, imageRotation: 0 },
            { id: "2", x: 147, y: 291, width: 332, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 147, y: 507, width: 332, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 702, y: 74, width: 234, height: 318, rotation: 0, imageRotation: 0 },
            { id: "5", x: 702, y: 399, width: 234, height: 317, rotation: 0, imageRotation: 0 },
            { id: "6", x: 943, y: 74, width: 234, height: 318, rotation: 0, imageRotation: 0 },
            { id: "7", x: 943, y: 399, width: 234, height: 317, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-05",
        name: "PO 05 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 57, y: 141, width: 510, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 479, width: 252, height: 163, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 479, width: 251, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 755, y: 141, width: 180, height: 248, rotation: 0, imageRotation: 0 },
            { id: "5", x: 755, y: 396, width: 180, height: 247, rotation: 0, imageRotation: 0 },
            { id: "6", x: 943, y: 141, width: 180, height: 248, rotation: 0, imageRotation: 0 },
            { id: "7", x: 943, y: 396, width: 180, height: 247, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-06",
        name: "PO 06 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 87, y: 74, width: 452, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 87, y: 506, width: 146, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 241, y: 506, width: 146, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 394, y: 506, width: 146, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 87, y: 364, width: 222, height: 135, rotation: 0, imageRotation: 0 },
            { id: "6", x: 317, y: 364, width: 222, height: 135, rotation: 0, imageRotation: 0 },
            { id: "7", x: 713, y: 74, width: 452, height: 635, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-07",
        name: "PO 07 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 87, y: 74, width: 222, height: 135, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 74, width: 222, height: 135, rotation: 0, imageRotation: 0 },
            { id: "3", x: 87, y: 215, width: 452, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 87, y: 506, width: 146, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 241, y: 506, width: 146, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 394, y: 506, width: 146, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 713, y: 74, width: 452, height: 635, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-08",
        name: "PO 08 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 185, width: 622, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 630, y: 185, width: 308, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 945, y: 185, width: 307, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 388, width: 150, height: 209, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 388, width: 150, height: 209, rotation: 0, imageRotation: 0 },
            { id: "6", x: 945, y: 388, width: 150, height: 209, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1103, y: 388, width: 149, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-09",
        name: "PO 09 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 201, width: 173, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 270, y: 331, width: 173, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 270, y: 460, width: 173, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 450, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 },
            { id: "6", x: 720, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 },
            { id: "7", x: 990, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-10",
        name: "PO 10 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 },
            { id: "3", x: 539, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 },
            { id: "4", x: 809, y: 201, width: 262, height: 381, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 201, width: 173, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 331, width: 173, height: 122, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1079, y: 460, width: 173, height: 122, rotation: 0, imageRotation: 0 }
        ],
    }
];